import React, { useEffect, useRef, useState } from 'react';
import { Route, Routes, Navigate, Outlet } from 'react-router-dom';
import Supplier from '../Supplier';
import Inventory from '../Inventory';
import Leads from '../Leads';
import Checklist from '../Checklist';
import Settings from '../Settings';
import OperationsDashboard from '../OperationsDashboard';
import InterveneDashboard from '../InterveneDashboard/index.tsx';
import DashboardRoutes from '../../Dashboards/routes/DashboardRoutes';
import PagesRoutes from '../../Dashboards/Pages/routes/PagesRoutes';
import MachadaloHeader from '../Header/Header.tsx';
import ManageSupplier from '../../ManageSupplier/ManageSupplier';
import { authAtom, userInformationAtom } from '../../Services/_states';
import { AddUpdateSupplierModal1 } from '../../components/AddUpdateSupplier/AddUpdateSupplierModal1.tsx';
import LeadWebForm from '../LeadWebForm/index';
import BookingContainer from '../../containers/BookingContainer';
import { useRecoilValue } from 'recoil';
import './index.css';
import OpsVerify from '../InterveneDashboard/OpsVerify';
import SuspenseSheet from '../InterveneDashboard/SuspenseSheet';
import Whatsapp from '../Whatsapp/Template';
import ErrorPage from '../Shared/ErrorPage';
import FileUpload from '../FileUploader';
import CallerAgentDashboard from '../CallerAgentDashboard';
import ManagementRoutes from '../Management';
import FlowList from '../FlowBuilder/Flow/FlowList.tsx';
import { globalpermissions } from '../../Services/Permission.js';
import ProtectedRoute from './ProtectedRoute.jsx';
import { ConstantActions } from '../../Services/_actions/constant.actions.js';
import MetaForm from '../Meta/index.tsx';
import SmsRoutes from '../SMS/index.tsx';
import LoginLogs from '../Login/LoginLogs.tsx';
import Account from '../Management/Account/index.tsx';
import AboutYou from '../Management/Account/AboutYou.tsx';
import ActivityLogs from '../Activity/ActivityLogs.tsx';
import DatasetsRoutes from '../Entity/index.tsx';
import CampaignRoutes from '../Campaign/index.tsx';
import Index from '../Scrapping/index.tsx';
import ScrapRouter from '../Scrapping/Router.tsx';
import ClientOnboarding from '../ClientOnboarding/index.tsx';
// import Account from '../Account/index.tsx';
import { useLocation } from 'react-router-dom';
import AI from '../AiChatbot/AI.tsx';
import Footer from '../Footer/Footer.tsx';
import { Container, useMediaQuery } from '@mui/material';
import FlowRoutes from '../FlowBuilder/index.tsx';
import InstructionSet from '../InstructionSet/instructionset.tsx';
import VectorRoutes from '../LLM/Knowledgebase/VectorRoute.jsx';
import Benchmarking from '../AiChatbot/Benchmarking.tsx';
import BenchmarkingReportDetails from '../AiChatbot/BenchmarkingReportDetails.tsx';
import NotificationWebSocket from '../Shared/NotificationWebSocket/index.tsx';
import SettingsRoute from '../Webhook/index.tsx';
import TestRoutes from '../examPortal/index.tsx';
import ParentTeacherDashboard from '../Test/ParentTeacherDashboard.tsx';
import Performance from '../PerformanceMap/PerformanceRoute.tsx';
import { WebSocketProvider } from '../../utils/WebSocketContext.tsx';
import ModernSidebar from '../Sidebar/ModernSidebar.tsx';
import MachadaloStudio from '../MachadaloStudio/index.tsx';

const Router = () => {
  const location = useLocation();
  const isStudentRoute = location.pathname.startsWith('/r/student/concept-builder');
  const actions = ConstantActions();
  const RequireAuth = () => {
    const auth = useRecoilValue(authAtom);
    if (!auth?.token) {
      return <Navigate to={`/r/login`} replace={true} />;
    }
    return (
      <>
        <Outlet />
      </>
    );
  };
  // const isSmallScreen = useMediaQuery('(max-width:1024px)');

  return (
    <main
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: '#fff',
        //margin: 0,  padding: 0
      }}
    >
      {/* <NotificationWebSocket/> */}
      <WebSocketProvider>
        {/* <ModernSidebar /> */}
        <MachadaloHeader />

        <div
          className="content-wrapper"
          style={{
            flex: 1,
            overflowY: 'auto',
            // paddingLeft: isSmallScreen ? 0 : 45,
          }}
        >
          <Container
            disableGutters
            maxWidth={false}
            // sx={{
            //   pt: { xl: '16px', lg: '16px', md: '14px', sm: '14px', xs: '16px' },
            //   pr: { xs: '10px', sm: '10px', md: '24px', lg: '16px', xl: '16px' },
            //   pl: { xs: '10px', sm: '10px', md: '24px', lg: '24px', xl: '24px' },
            //   height: { xs: '100%', sm: 'auto' },
            // }}
            sx={{
              pt: isStudentRoute
                ? 0
                : { xl: '16px', lg: '16px', md: '14px', sm: '14px', xs: '16px' },
              pr: isStudentRoute
                ? 0
                : { xs: '10px', sm: '10px', md: '24px', lg: '16px', xl: '16px' },
              pl: isStudentRoute
                ? 0
                : { xs: '10px', sm: '10px', md: '24px', lg: '24px', xl: '24px' },
              height: { xs: '100%', sm: 'auto' },
            }}
          >
            <Routes>
              <Route path="*" element={<ErrorPage />} />
              <Route path="/*" element={<RequireAuth />}>
                <Route
                  path={'dashboard/*'}
                  element={
                    <ProtectedRoute
                      element={<DashboardRoutes />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.businessDashboard,
                        globalpermissions?.navBar?.menuOpsDashBoard,
                      ])}
                    />
                  }
                />
                <Route
                  path={`checklist/*`}
                  element={
                    <ProtectedRoute
                      element={<Checklist />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.navBar?.menuCampaignLeads,
                        globalpermissions?.navBar?.menuChecklist,
                      ])}
                    />
                  }
                />
                <Route
                  path={`supplier/*`}
                  element={
                    <ProtectedRoute
                      element={<Supplier />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.dynamicSupplierPageAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={`inventory/*`}
                  element={
                    <ProtectedRoute
                      element={<Inventory />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.dynamicInventoryPageAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={`settings/*`}
                  element={
                    <ProtectedRoute
                      element={<Settings />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.settingPageAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={`records/*`}
                  element={
                    <ProtectedRoute
                      element={<Leads />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.navBar?.menuCampaignLeads,
                        globalpermissions?.pagePermissions?.campaignLeadsPageAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={`operations-dashboard/*`}
                  element={
                    <ProtectedRoute
                      element={<OperationsDashboard />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.entityReportPageAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={`manageSupplier/*`}
                  element={
                    <ProtectedRoute
                      element={<ManageSupplier />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.manageSupplierFormAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path="intervene-dashboard/*"
                  element={
                    <ProtectedRoute
                      element={<InterveneDashboard isInterveneDashboard={true} />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.interveneNew,
                      ])}
                    />
                  }
                />
                <Route
                  path={`e-commerce/*`}
                  element={
                    <ProtectedRoute
                      element={<InterveneDashboard />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.ecommerceDashboard,
                      ])}
                    />
                  }
                />
                <Route
                  path={`edit-supplier/:phone_number/*`}
                  element={
                    <ProtectedRoute
                      element={<AddUpdateSupplierModal1 />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.supplierBookingPage?.editSupplier,
                      ])}
                    />
                  }
                />

                <Route
                  path={`lead-web-form/*`}
                  element={
                    <ProtectedRoute
                      element={<LeadWebForm />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.webFormPageAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={`lead-web-form/:phone_number/*`}
                  element={
                    <ProtectedRoute
                      element={<LeadWebForm />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.webFormPageAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={`lead-web-form/:phone_number/:leadId/*`}
                  element={
                    <ProtectedRoute
                      element={<LeadWebForm />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.webFormPageAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={'ops-verify/*'}
                  element={
                    <ProtectedRoute
                      element={<OpsVerify />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.opsDashBoardPage,
                      ])}
                    />
                  }
                />
                <Route
                  path={'suspense-sheet/*'}
                  element={
                    <ProtectedRoute
                      element={<SuspenseSheet />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.suspenseLeadSheetPageAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={'whatsapp/*'}
                  element={
                    <ProtectedRoute
                      element={<Whatsapp />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.templateDashboardNew,
                      ])}
                    />
                  }
                />
                <Route
                  path={`caller-dashboard/*`}
                  element={
                    <ProtectedRoute
                      element={<CallerAgentDashboard />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.dashboard?.callerAgentDashboard,
                      ])}
                    />
                  }
                />
                <Route
                  path={`meta/*`}
                  element={
                    <ProtectedRoute
                      element={<MetaForm />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.dashboard?.metaForm,
                      ])}
                    />
                  }
                />
                <Route path={'management/*'} element={<ManagementRoutes />} />
                {/* <Route path={`flow-list/*`} element={<FlowList />} />
              <Route path={`flow-builder/:flowId`} element={<ChatbotBuilder />} /> */}
                <Route
                  path={'flow/*'}
                  element={
                    <ProtectedRoute
                      element={<FlowRoutes />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.flowBuilderAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={`sms/*`}
                  element={
                    <ProtectedRoute
                      element={<SmsRoutes />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.smsDashboardAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={`activity-logs/*`}
                  element={
                    <ProtectedRoute
                      element={<ActivityLogs />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.navBar?.menuActivityLogs,
                      ])}
                    />
                  }
                />
                <Route
                  path={`login-logs/*`}
                  element={
                    <ProtectedRoute
                      element={<LoginLogs />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.navBar?.menuLoginLogs,
                      ])}
                    />
                  }
                />
                <Route
                  path={`url-genrator/*`}
                  element={
                    <ProtectedRoute
                      element={<FileUpload />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.urlGeneratorPageAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={`datasets/*`}
                  element={
                    <ProtectedRoute
                      element={<DatasetsRoutes />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.selfServiceFormsAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={`campaign/*`}
                  element={
                    <ProtectedRoute
                      element={<CampaignRoutes />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.navBar?.menuCampaignList,
                        globalpermissions?.pagePermissions?.campaignListPageAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={`pages/*`}
                  element={
                    <ProtectedRoute
                      element={<PagesRoutes />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.pagesRoutesAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={`tools/*`}
                  element={
                    <ProtectedRoute
                      element={<ScrapRouter />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.urlGeneratorPageAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={'Client-onboarding/*'}
                  element={
                    <ProtectedRoute
                      element={<ClientOnboarding />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.clientOnboardingPageAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={'ai/*'}
                  element={
                    <ProtectedRoute
                      element={<AI />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.aiAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={'ai/benchmarking-report'}
                  element={
                    <ProtectedRoute
                      element={<Benchmarking />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.benchmarkingAccess,
                      ])}
                    />
                  }
                />
                {/* <Route path={'ai/benchmarking-report'} element={<BenchmarkingReportDetails />} /> */}
                <Route
                  path={'instruction-set/*'}
                  element={
                    <ProtectedRoute
                      element={<InstructionSet />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.instructionSet,
                      ])}
                    />
                  }
                />
                <Route
                  path={'vector/*'}
                  element={
                    <ProtectedRoute
                      element={<VectorRoutes />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.vectorDatabaseAccess,
                      ])}
                    />
                  }
                />
                <Route
                  path={'setting/*'}
                  element={
                    <ProtectedRoute
                      element={<SettingsRoute />}
                      permissionGranted={actions.userHasPermission([
                        globalpermissions?.pagePermissions?.setting,
                      ])}
                    />
                  }
                />
              </Route>
              <Route
                path={`test/*`}
                element={<ProtectedRoute element={<TestRoutes />} permissionGranted={true} />}
              />
              <Route
                path={`student/*`}
                element={<Performance />}
                // element={
                //   <ProtectedRoute
                //     element={<Performance />}
                //     permissionGranted={actions.userHasPermission([
                //       globalpermissions?.pagePermissions?.studentDashboard,
                //     ])}
                //   />
                // }
              />
              <Route
                path="dashboard/:type"
                element={
                  <ProtectedRoute
                    element={<ParentTeacherDashboard />}
                    permissionGranted={actions.userHasPermission([
                      globalpermissions?.pagePermissions?.parentTeacherDashboard,
                    ])}
                  />
                }
              />
              <Route path="machadalostudio/*" element={<MachadaloStudio />} />
            </Routes>
          </Container>
        </div>
      </WebSocketProvider>
      {/* <Footer style={{ position: 'fixed', bottom: 0, width: '100%',paddingLeft: 45, }} /> */}
    </main>
  );
};

export default Router;
